"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DUNEA_DEVELOPER = void 0;
exports.firstPartyTheme = firstPartyTheme;
exports.DUNEA_DEVELOPER = {
    name: 'Dunea',
    supportEmail: 'support@dunea.ai',
    privacyUrl: 'https://dunea.ai/privacy',
    website: 'https://dunea.ai',
};
/**
 * A first-party theme manifest. Icon and screenshots are placeholder URLs under
 * https://dunea.ai/themes/<id>/ until the real artwork is uploaded.
 */
function firstPartyTheme(body) {
    return {
        schemaVersion: 1,
        kind: 'theme',
        version: '1.0.0',
        developer: exports.DUNEA_DEVELOPER,
        pricing: { model: 'free' },
        icon: `https://dunea.ai/themes/${body.id}/icon.png`,
        screenshots: [`https://dunea.ai/themes/${body.id}/screenshot-1.png`],
        ...body,
    };
}
